// Welches Programm gerade läuft (setzt starteProgramm); die Hülle zeigt danach Seitenleiste und Titel.
import { createContext, useContext } from "react";
import type { ProgrammId } from "../navigation/katalog";

export const ProgrammKontext = createContext<ProgrammId>("start");

export function useProgramm(): ProgrammId {
  return useContext(ProgrammKontext);
}
